import React from 'react';
import { injectIntl } from 'react-intl';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { Badge, Box, Typography } from '@mui/material';
import { connect } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { List as IList } from 'immutable';
import { useLocation } from 'react-router-dom';
import { getAllActiveCards, getTotalCardQuantity } from '../productCartHandler/productCartSelectors';
import { getCartIconForMobileStatus } from '../localeCurrencyPicker/LocaleCurrencyPickerSelector';
import { useFlow } from '../routing/FlowProvider';
import { CART_STEP, PAYMENT, ROUTES } from '../routing/flowConstants';
import { trackGenericCartSegment } from '../segment/segmentModule';
import { getCartTextMessage, getProductsSegmentData } from './cartSelectors';
import { isMobileview } from '../utils/deviceTypeUtils';
import windowSize from '../utils/windowSize';
import { getIsBuyNowFlow } from '../routing/routingSelectors';
import { BuyNowCartIcon } from '../primitive/icons/cartIcons';

import CartPageMessages from './messages/cartPageMessages';

const CartIcon = ({
    totalCardsCount, isCartIconForMobileStatus, activeCards, trackCartViewedAction, additionalInfo, intl,
    windowWidth, cartTextMessage, isBuyNowFlow
}) => {
    const { goToStep } = useFlow();
    const location = useLocation();
    const currentStep = Object.keys(ROUTES).find(
        step => ROUTES[step] === location.pathname
    );
    const isPaymentPage = currentStep === PAYMENT;
    
    const isMobile = isMobileview(windowWidth);
    return (
        <Box
            className={classnames(
                'cart-icon-badge-container',
                { 'no-badge': totalCardsCount },
                { 'hide-cart': !isCartIconForMobileStatus }
            )}
        >
            <a
                className={classnames('cart-icon-button', 'cart-icon-link', 'custom-cart-icon-class')}
                href="/cart"
                onClick={(e) => {
                    if (totalCardsCount) {
                        const newAdditionalInfo = {
                            ...additionalInfo,
                            parent: 'cart-icon-badge-container'
                        };
                        const segmentEventName = 'Cart Viewed';
                        trackCartViewedAction(activeCards, newAdditionalInfo, segmentEventName);
                    }
                    
                    e.preventDefault();
                    goToStep(CART_STEP);
                }}
            >
                <Badge
                    badgeContent={totalCardsCount}
                    color='error'
                    overlap='rectangular'
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                    className='cart-icon-badge'
                    invisible={(isBuyNowFlow && isPaymentPage) || !totalCardsCount}
                    componentsProps={{
                        badge: {
                            'aria-hidden': true
                        }
                    }}
                >
                    {isBuyNowFlow && isPaymentPage ? (
                        <BuyNowCartIcon
                            className='cart-icon'
                            aria-hidden="true"
                            showBadge={!!totalCardsCount}
                        />
                    ) : (
                        <ShoppingCartOutlinedIcon
                            className='cart-icon'
                            aria-hidden="true"
                            sx={{
                                ml: 0.5,
                                color: 'inherit',
                                
                                '& path': { fill: 'currentColor' }
                            }}
                        />
                    )}
                    {}
                    <span
                        className='visually-hidden-span'
                    >
                        {intl.formatMessage(CartPageMessages.cartSummaryText, { count: totalCardsCount })}
                    </span>
                </Badge>
                {!isMobile && cartTextMessage && (
                    <Typography
                        aria-hidden="true"
                        className={classnames(
                            'manage-gift-card-text',
                            'cartText',
                            { badge: totalCardsCount > 0 }
                        )}
                    >
                        {cartTextMessage}
                    </Typography>
                )}
            </a>
        </Box>
    );
};

CartIcon.defaultProps = {
    cartTextMessage: null
};

CartIcon.propTypes = {
    isCartIconForMobileStatus: PropTypes.bool.isRequired,
    totalCardsCount: PropTypes.number.isRequired,
    activeCards: PropTypes.instanceOf(IList).isRequired,
    trackCartViewedAction: PropTypes.func.isRequired,
    additionalInfo: PropTypes.shape({}).isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired,
    windowWidth: PropTypes.number.isRequired,
    cartTextMessage: PropTypes.string,
    isBuyNowFlow: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownprops) => ({
    isCartIconForMobileStatus: getCartIconForMobileStatus(state),
    totalCardsCount: getTotalCardQuantity(state),
    
    activeCards: getAllActiveCards(state),
    additionalInfo: getProductsSegmentData(state, ownprops.intl),
    cartTextMessage: getCartTextMessage(state),
    isBuyNowFlow: getIsBuyNowFlow(state)
});

const mapDispatchToProps = {
    trackCartViewedAction: trackGenericCartSegment
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    windowSize(
        injectIntl(CartIcon)
    )
);
